<button class="burger-menu-dialog-close" mat-icon-button mat-dialog-close>
    <mat-icon matSuffix>close</mat-icon>
</button>

<mat-dialog-content class="toolbar px-md-8 pt-6">
    <menu>
        @for (item of navItemList | navItemAccess: (settings$ | async); track $index) {
            <div class="mb-3">
                @if (item.path) {
                    <a class="a--border-off" (click)="transitionRouteWithCloseModal($event, item.path)"
                       [attr.title]="item.title | translate" role="presentation">
                        {{ item.title | translate }}
                    </a>
                }
            </div>
        }
    </menu>
</mat-dialog-content>
